module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/exchange-section-4ca8edada62c971428d85e8c9d3f1778.png";